import React from "react";
import LinkTo from "../../../wrappers/LinkTo";
import { Button } from "@mui/material";
import { AccountCircleOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { PROFILE_EDIT } from "../../../../enums/UrlPaths";

export default function UserProfile({ handleClose }) {
  const { t } = useTranslation();

  return (
    <LinkTo to={PROFILE_EDIT}>
      <Button
        sx={{
          display: "flex",
          justifyContent: "start",
          gap: 2,
          pl: 2,
        }}
        onClick={() => handleClose()}
        size="large"
        variant="text"
        color="info"
        startIcon={<AccountCircleOutlined />}
        fullWidth
        data-testid="header.user-menu.my-profile-button"
      >
        {t("Profile")}
      </Button>
    </LinkTo>
  );
}
